import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/Common/ExploreCampus/ExploreCampusWrapper.tsx");
